/**
 * Shared form fields for department create/edit.
 * Shift times and weekdays drive staff availability when a QR is scanned.
 */

import {
  TextInput,
  SelectInput,
  CheckboxGroupInput,
  TimeInput,
  required,
  useGetList,
  useTranslate,
} from 'react-admin';

// Day ids follow JS getDay(): 0 = Sunday (what the backend availability check uses)
const WEEKDAY_CHOICES: { id: number; key: string }[] = [
  { id: 1, key: 'monday' },
  { id: 2, key: 'tuesday' },
  { id: 3, key: 'wednesday' },
  { id: 4, key: 'thursday' },
  { id: 5, key: 'friday' },
  { id: 6, key: 'saturday' },
  { id: 0, key: 'sunday' },
];

export const DepartmentFormFields = ({ isCreate }: { isCreate: boolean }) => {
  const translate = useTranslate();
  const { data: organizations } = useGetList('organizations', {
    pagination: { page: 1, perPage: 500 },
    sort: { field: 'full_name', order: 'ASC' },
  });

  return (
    <>
      <TextInput source="name" validate={required()} />
      <TextInput source="description" validate={required()} multiline />
      <SelectInput
        source="organization_id"
        validate={required()}
        disabled={!isCreate}
        choices={(organizations ?? []).map((org: any) => ({
          id: org.user_id,
          name: org.company_name || org.full_name,
        }))}
      />
      <TimeInput source="start_shift" />
      <TimeInput source="end_shift" />
      <CheckboxGroupInput
        source="weekdays"
        choices={WEEKDAY_CHOICES.map(({ id, key }) => ({
          id,
          name: translate(`common.weekdays.${key}`, { _: key }),
        }))}
      />
    </>
  );
};

export default DepartmentFormFields;
